const {
  cacheTtlMilliseconds,
  defaultCacheTtlMilliseconds
} = require('./cache');
const { slugifyPreviewName } = require('../../../shared/preview-slug');

function emptySiteForm() {
  return {
    id: null,
    name: '',
    previewSlug: '',
    origin: '',
    domain: '',
    captures: [{ url: '', method: 'POST', match: 'exact' }],
    ignoredRoutes: [''],
    minimum: 200,
    renderer: 'chromium',
    quiet: 200,
    cacheTtl: defaultCacheTtlMilliseconds / 1000
  };
}

function siteForm(site) {
  const captures = (site.renderOptions?.capture || []).map(capture => ({
    url: capture.url,
    method: capture.methods?.[0] || 'POST',
    match: capture.match || (capture.url.includes('*') ? 'wildcard' : 'exact')
  }));
  const ignoredRoutes = site.renderOptions?.ignoredRoutes || [];

  return {
    id: site.id,
    name: site.name,
    previewSlug: site.previewSlug || slugifyPreviewName(site.name),
    origin: site.origin,
    domain: '',
    captures: captures.length ? captures : [{ url: '', method: 'POST', match: 'exact' }],
    ignoredRoutes: ignoredRoutes.length ? [...ignoredRoutes] : [''],
    minimum: site.renderOptions?.wait?.minimum ?? 200,
    renderer: site.renderOptions?.renderer || 'chromium',
    quiet: site.renderOptions?.wait?.quiet ?? 200,
    cacheTtl: Math.round(cacheTtlMilliseconds(site.renderOptions?.cacheTtl) / 1000)
  };
}

function addCapture(form) {
  form.captures.push({ url: '', method: 'POST', match: 'exact' });
}

function addIgnoredRoute(form) {
  form.ignoredRoutes.push('');
}

function removeIgnoredRoute(form, index) {
  form.ignoredRoutes.splice(index, 1);
}

function updateSiteForm(form, name, captureIndex, value) {
  if (name === 'captureUrl') {
    form.captures[captureIndex].url = value;
    return;
  }

  if (name === 'captureMethod') {
    form.captures[captureIndex].method = value;
    return;
  }

  if (name === 'captureMatch') {
    form.captures[captureIndex].match = value;
    return;
  }

  if (name === 'ignoredRoute') {
    form.ignoredRoutes[captureIndex] = value;
    return;
  }

  form[name] = value;
}

module.exports = {
  addCapture,
  addIgnoredRoute,
  emptySiteForm,
  removeIgnoredRoute,
  siteForm,
  updateSiteForm
};
